import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InterchangeService } from './interchange.service';


@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [],
  exports: [],
  providers: [InterchangeService],
})
export class InterchangeModule {}
